//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/politicas-de-privacidade',
      en: '/privacy-policies',
      es: '/politicas-de-privacidad'
    }
  },

  asyncData({ store, error }) {
    const privacy = store.getters['layout/getPrivacy']

    if (privacy) {
      return {
        privacy
      }
    } else {
      return error({ statusCode: 404 })
    }
  },

  data() {
    return {
      privacy: ''
    }
  },

  head() {
    return this.$helpers.seoBuilder(this, {
      staticTitle: this.$t('title')
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/politicas-de-privacidade'
        }
      ]

      return breadcrumbs
    }
  }
}
